Ext.define('SA.model.color.Color', {
    extend: 'Ext.data.Model',

    fields: [
        {
            name: 'color',

            convert(value) {
                return value.toUpperCase();
            }
        }, {
            name: 'r',

            convert(value, record) {
                if (typeof value !== 'number') {
                    return Ext.draw.Color.fromString('#' + record.getColor()).getRed();
                }

                return value;
            }
        }, {
            name: 'g',

            convert(value, record) {
                if (typeof value !== 'number') {
                    return Ext.draw.Color.fromString('#' + record.getColor()).getGreen();
                }

                return value;
            }
        }, {
            name: 'b',

            convert(value, record) {
                if (typeof value !== 'number') {
                    return Ext.draw.Color.fromString('#' + record.getColor()).getBlue();
                }

                return value;
            }
        }, {
            name: 'h',

            convert(value, record) {
                if (typeof value !== 'number') {
                    return Ext.draw.Color.fromString('#' + record.getColor()).getHSL()[0] || 0;
                }

                return value;
            }
        }, {
            name: 's',

            convert(value, record) {
                if (typeof value !== 'number') {
                    return Ext.draw.Color.fromString('#' + record.getColor()).getHSL()[1];
                }

                return value;
            }
        }, {
            name: 'l',

            convert(value, record) {
                if (typeof value !== 'number') {
                    return Ext.draw.Color.fromString('#' + record.getColor()).getHSL()[2];
                }

                return value;
            }
        }
    ],

    derive(component, value) {
        var parts = this.getData();

        parts[component] = value;

        if (/r|g|b/.test(component)) {
            return new SA.model.color.Color({
                color: toHex(parts.r) + toHex(parts.g) + toHex(parts.b)
            });
        }
        else if (/h|s|l/.test(component)) {
            let color = new SA.model.color.Color({
                color: Ext.draw.Color.fromHSL(parts.h, parts.s, parts.l).toString().replace('#', '')
            });

            color.set({
                h: parts.h,
                s: parts.s,
                l: parts.l
            });

            return color;
        }

        throw new Error('Unknown component');

        function toHex(num) {
            num = Math.round(num);

            return (num < 16 ? '0' : '') + num.toString(16);
        }
    },

    getColor() {
        return this.get('color');
    },

    getHue() {
        return this.get('h');
    },

    getLuminance() {
        return this.get('l');
    }
});
